import React from 'react';

export const DuplicateTarget = () => {
  return (
    <button
      type="button"
      className="target-duplicate-def"
      data-test="DuplicateTarget"
    >
      Duplicate
    </button>
  );
};
